import type { DocPageContent } from '../types';

/**
 * "Labs" — Dashboard section (ADR-0074).
 *
 * The switchboard every other page in this section eventually points at. It is
 * short on purpose: enumerating today's toggles would be a list that is wrong
 * within a release, and each toggle already carries its own explanation in the
 * product. What the page owes a reader is the RULES — who can change them, what
 * scope they take, and what a switch being off looks like from the outside —
 * because those are stable and are what makes a missing sidebar entry
 * diagnosable instead of mysterious.
 *
 * Reconciled from apps/web `features/experimental-features` (route
 * `/settings/experimental`) and the `labs.*` catalog.
 */
export const DASHBOARD_LABS_PAGE: DocPageContent = {
  slug: 'dashboard/labs',
  titleKey: 'docs.dashboard.labs.title',
  descriptionKey: 'docs.dashboard.labs.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.labs.lead' },

    { kind: 'heading', level: 2, id: 'rules', textKey: 'docs.dashboard.labs.rules.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.labs.rules.item.workspace',
        'docs.dashboard.labs.rules.item.who',
        'docs.dashboard.labs.rules.item.instant',
        'docs.dashboard.labs.rules.item.stage',
      ],
    },

    { kind: 'heading', level: 2, id: 'missing', textKey: 'docs.dashboard.labs.missing.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.labs.missing.body' },

    { kind: 'heading', level: 2, id: 'safety', textKey: 'docs.dashboard.labs.safety.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.labs.safety.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.labs.safety.note.title',
      textKey: 'docs.dashboard.labs.safety.note.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.labs.next.mapping.title',
          textKey: 'docs.dashboard.labs.next.mapping.text',
          to: { docSlug: 'dashboard/site-mapping' },
        },
        {
          titleKey: 'docs.dashboard.labs.next.experience.title',
          textKey: 'docs.dashboard.labs.next.experience.text',
          to: { docSlug: 'dashboard/experience' },
        },
        {
          titleKey: 'docs.dashboard.labs.next.settings.title',
          textKey: 'docs.dashboard.labs.next.settings.text',
          to: { docSlug: 'dashboard/settings' },
        },
      ],
    },
  ],
};
